import script from "./BaseChartPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseChartPanel.vue?vue&type=script&setup=true&lang=js"

import "./BaseChartPanel.vue?vue&type=style&index=0&id=4b5dbda7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5dbda7"]])

export default __exports__